import React from "react";

export function PaginatedDataTable({ columns, rows, total, offset, limit, onPageChange, isLoading, renderCell }) {
    const currentPage = Math.floor(offset / limit) + 1;
    const totalPages = Math.ceil(total / limit) || 1;

    return (
        <div className="w-full bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full text-left text-sm text-slate-600">
                    <thead className="bg-slate-50 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-100">
                        <tr>
                            {columns.map((col) => (
                                <th key={col.key} className="px-3.5 py-3.5 text-left font-medium">
                                    {col.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {isLoading ? (
                            <tr>
                                <td colSpan={columns.length} className="px-4 py-12 text-center text-slate-400">
                                    <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-indigo-600"></div>
                                    <p className="mt-2 text-xs">Loading requests...</p>
                                </td>
                            </tr>
                        ) : rows.length === 0 ? (
                            <tr>
                                <td colSpan={columns.length} className="px-4 py-12 text-center text-slate-400">
                                    No RFQs found.
                                </td>
                            </tr>
                        ) : (
                            rows.map((row, idx) => (
                                <tr key={row.rfq_id || idx} className="hover:bg-slate-50/80 transition-colors">
                                    {columns.map((col) => (
                                        <td
                                            key={col.key}
                                            className="px-3.5 py-3 whitespace-nowrap text-xs max-w-[180px] truncate"
                                            title={typeof row[col.key] === 'string' ? row[col.key] : ''}
                                        >
                                            {renderCell ? renderCell(row, col.key) : row[col.key]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                    {/* <thead className="bg-slate-50 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-100">
                        <tr>
                            {columns.map((col) => (
                                <th key={col.key} className="px-6 py-4">{col.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {isLoading ? (
                            <tr>
                                <td colSpan={columns.length} className="px-6 py-12 text-center text-slate-400">
                                    <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-indigo-600"></div>
                                    <p className="mt-2 text-xs">Loading requests...</p>
                                </td>
                            </tr>
                        ) : rows.length === 0 ? (
                            <tr>
                                <td colSpan={columns.length} className="px-6 py-12 text-center text-slate-400">
                                    No RFQs found.
                                </td>
                            </tr>
                        ) : (
                            rows.map((row, idx) => (
                                <tr key={row.rfq_id || idx} className="hover:bg-slate-50/80 transition-colors">
                                    {columns.map((col) => (
                                        <td key={col.key} className="px-6 py-4 whitespace-nowrap">
                                            {renderCell ? renderCell(row, col.key) : row[col.key]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody> */}
                </table>
            </div>

            {/* Pagination Footer */}
            <div className="flex items-center justify-between px-6 py-4 bg-slate-50/50 border-t border-slate-100 text-xs text-slate-500">
                <div>
                    Showing <span className="font-semibold text-slate-700">{total === 0 ? 0 : offset + 1}</span> to{" "}
                    <span className="font-semibold text-slate-700">{Math.min(offset + limit, total)}</span> of{" "}
                    <span className="font-semibold text-slate-700">{total}</span> entries
                </div>
                <div className="flex items-center space-x-2">
                    <button
                        disabled={offset === 0 || isLoading}
                        onClick={() => onPageChange(offset - limit)}
                        className="px-3 py-1.5 rounded-md border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition"
                    >
                        Previous
                    </button>
                    <span className="px-2 font-medium">Page {currentPage} of {totalPages}</span>
                    <button
                        disabled={offset + limit >= total || isLoading}
                        onClick={() => onPageChange(offset + limit)}
                        className="px-3 py-1.5 rounded-md border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition"
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
}